import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Chip, Tooltip } from "@material-ui/core";
import { observer } from "mobx-react";

class CustomClipFeedSelector extends React.Component {
  getChipLabel = (name) => {
    return name.startsWith("DM5-") ? "MLB.TV" : "Internal";
  };

  getChipColor = (name) => {
    return name.startsWith("DM5-") ? "primary" : "default";
  };

  render() {
    const { createCustomClipStore, onFeedChange } = this.props;

    return (
      <FormControl
        style={{ float: "right", marginBottom: "1rem", width: "16rem" }}
      >
        <InputLabel id="diamond-hls-feed">Feed</InputLabel>
        <Select
          labelId="diamond-hls-feed-label"
          id="diamond-hls-feed-select"
          label="Diamond Feed"
          value={
            createCustomClipStore.selectedAsset &&
            createCustomClipStore.selectedAsset.name
              ? createCustomClipStore.selectedAsset.name.toUpperCase()
              : ""
          }
          onChange={e =>
            createCustomClipStore
              .setClipFeedByAssetName(e.target.value)
              .then(() => onFeedChange && onFeedChange())
          }
        >
          {createCustomClipStore.assets &&
            createCustomClipStore.assets.length > 0 &&
            createCustomClipStore.assets.map(asset => (
              <MenuItem key={asset.name} value={asset.name.toUpperCase()}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center"
                  }}
                >
                  <span>{asset.feedType.toUpperCase()}</span>
                  <Tooltip title={asset.name} placement="right">
                    <Chip
                      label={this.getChipLabel(asset.name)}
                      color={this.getChipColor(asset.name)}
                      size="small"
                    />
                  </Tooltip>
                </div>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}

export default observer(CustomClipFeedSelector);



// WEBPACK FOOTER //
// ./src/components/CustomClipFeedSelector.js